import React from 'react';
import useAppMethods from '../../hooks/utility/useAppMethods';
import { BuyGiftCardForm } from './types';
import CustomButton from '../../components-library/buttons/CustomButton';
import { ButtonTypes } from '../../services/exports/Interfaces';
import { useTranslation } from 'react-i18next';

const ConfirmationAlertTitle = (props: BuyGiftCardForm) => {
  const { formatCurrency } = useAppMethods();
  const { t } = useTranslation(null, { keyPrefix: 'Modals:BuyGiftCardModal.confirmation.title' });
  const selectedValue = props.value / 100 || props.custom_value;
  const value = formatCurrency(selectedValue);

  return (
    <div className="space-y-xs">
      <span>{t('title')}</span>
      <p className="text-muted-foreground">{t('subtitle', { value, count: props.quantity })}</p>
    </div>
  );
};

const ConfirmationAlertDescription = (props: BuyGiftCardForm) => {
  const { formatCurrency } = useAppMethods();
  const { t } = useTranslation(null, { keyPrefix: 'Modals:BuyGiftCardModal.confirmation.description' });
  const selectedValue = props.value / 100 || props.custom_value;
  const value = formatCurrency(selectedValue);
  const total = formatCurrency(+selectedValue * props.quantity);

  return (
    <div className="rounded-lg bg-slate-100">
      <div className="p-md space-y-md [&_p]:text-sm md:[&_p]:text-base">
        <p className="text-muted-foreground flex justify-between items-center">
          <p>{t('amount')}</p>
          <p className="text-black font-medium">{value}</p>
        </p>
        <p className="text-muted-foreground flex justify-between items-center">
          <p>{t('quantity')}</p>
          <p className="text-black font-medium">{props.quantity}</p>
        </p>
        <p className="text-muted-foreground flex justify-between items-center gap-2">
          <p className="shrink-0">{t('email')}</p>
          <p className="text-black font-medium truncate">{props.email}</p>
        </p>
        <hr />
        <p className="text-muted-foreground flex justify-between items-center">
          <p className="text-black font-semibold">{t('total')}</p>
          <p className="text-black font-semibold">{total}</p>
        </p>
      </div>
    </div>
  );
};

interface ConfirmationAlertFooter {
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationAlertFooter = ({ onConfirm, onCancel }: ConfirmationAlertFooter) => {
  const { t } = useTranslation(null, { keyPrefix: 'Modals:BuyGiftCardModal.confirmation.footer' });

  return (
    <div className="flex gap-md mt-md">
      <CustomButton
        title={t('cancel')}
        buttonType={ButtonTypes.forth}
        className="!border-brand-border bg-white shadow-none"
        titleClass="!text-black"
        onClick={onCancel}
      />
      <CustomButton title={t('confirm')} onClick={onConfirm} />
    </div>
  );
};

export default {
  Title: ConfirmationAlertTitle,
  Description: ConfirmationAlertDescription,
  Footer: ConfirmationAlertFooter,
};
